import { Orientation, View } from "@/types/types";
import styles from "./orientation-view.module.css";
import { useTranslations } from "next-intl";

export default function ViewSelector({
  currentView,
  error,
  onClick,
}: {
  currentView: View;
  error: string | undefined;
  onClick: (newValue: View) => void;
}) {
  const t = useTranslations("NewListing.View");

  return (
    <div className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${error && styles.error}`}>
        {t("viewTitle")}
      </h3>
      <p className={styles.fieldDescription}>{t("viewDescription")}</p>
      <ul className={styles.wrapper}>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentView,
                sea_view: !currentView.sea_view,
              });
            }}
            className={`${styles.pill} ${styles.viewPill} ${
              currentView.sea_view ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("sea-view")}
          </button>
        </li>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentView,
                mountain_view: !currentView.mountain_view,
              });
            }}
            className={`${styles.pill} ${styles.viewPill} ${
              currentView.mountain_view ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("mountain-view")}
          </button>
        </li>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentView,
                countryside_view: !currentView.countryside_view,
              });
            }}
            className={`${styles.pill} ${styles.viewPill} ${
              currentView.countryside_view ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("countryside-view")}
          </button>
        </li>
        <li>
          <button
            onClick={(e) => {
              e.preventDefault();
              onClick({
                ...currentView,
                city_view: !currentView.city_view,
              });
            }}
            className={`${styles.pill} ${styles.viewPill} ${
              currentView.city_view ? styles.active : ""
            }`}
            aria-pressed={false}
          >
            {t("city-view")}
          </button>
        </li>
      </ul>
    </div>
  );
}
